export default function Profile({users}) {
 
  return (
    <div className="flex gap-x-3 items-center justify-center">
      <img
        className="w-16 rounded-full "
        src={require("./../../../../assets/images/userIcon.png")}
        alt=""
      />
      <div className="flex flex-col justify-center text-gray-800 dark:text-white">
        <p>{users?.name}</p>
        <span>{users?.role == "admin" ? "ادمین" : users?.role}</span>
      </div>
    </div>
  );
}
